import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  selectIsOnCancelPressed,
  selectIsOnConfirmPressed,
  setIsOnCancelPressed,
  setIsOnConfirmPressed,
  setIsShowEstimationInterruptModal,
} from "../../../../../../redux/features/solar-estimation/solarEstimationSlice";
import { AppRoute } from "../../../../interfaces/app-routes";
import MaterialIcon, {
  MtIcon,
} from "../../../../ui-elements/material-icon/material-icon";
import { isOnEstimation } from "../../../../utils/solarEstimationHelper";
import styles from "./menu-item.module.scss";

interface IProps {
  active: boolean;
  collapsed?: boolean;
  to?: AppRoute | string;
  icon?: MtIcon;
  text?: string;
  onClick?: () => void;
  enableRoute?: boolean;
  bgColor?: string;
  bgColorIcon?: string;
}

const MenuItem = (props: IProps) => {
  const { enableRoute = true } = props;
  const [navigateOnInterruption, setNavigateOnInterruption] = useState("");

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const pathname = location.pathname;
  const isOnConfirmPressed = useSelector(selectIsOnConfirmPressed);
  const isOnCancelPressed = useSelector(selectIsOnCancelPressed);

  useEffect(() => {
    if (isOnConfirmPressed && navigateOnInterruption) {
      dispatch(setIsShowEstimationInterruptModal(false));
      dispatch(setIsOnConfirmPressed(false));
      setNavigateOnInterruption("");
      navigate(navigateOnInterruption);
    }
  }, [isOnConfirmPressed, navigateOnInterruption]);

  useEffect(() => {
    if (isOnCancelPressed && navigateOnInterruption) {
      setNavigateOnInterruption("");
      dispatch(setIsOnCancelPressed(false));
    }
  }, [isOnCancelPressed, navigateOnInterruption]);

  return (
    <>
      <div
        className={`${
          props.active && enableRoute
            ? `${styles[`active`]} ${props.bgColor}`
            : ``
        }  p-1`}
        onClick={
          enableRoute
            ? (e) => {
                props.onClick && props.onClick();
              }
            : undefined
        }
      >
        <div
          onClick={() => {
            if (enableRoute && props.to) {
              if (isOnEstimation(pathname)) {
                dispatch(setIsShowEstimationInterruptModal(true));
                setNavigateOnInterruption(props.to);
                return;
              }
              navigate(props.to);
            }
          }}
          className={`text-decoration-none d-flex align-items-center text-label font-size-16 font-weight-400 cursor-pointer ${
            props.collapsed ? "p-2" : "gap-2"
          }p-2 ${!enableRoute && styles.disable}`}
          style={props.collapsed ? {} : { width: "155px" }}
        >
          <MaterialIcon
            icon={props.icon}
            size={20}
            color={
              props.active && enableRoute
                ? `var(${props.bgColorIcon})`
                : "var(--color-close-icon)"
            }
          />
          {!props.collapsed && <span className="ms-2">{props.text}</span>}
        </div>
      </div>
    </>
  );
};

export default MenuItem;
